import { keywordNodes } from "@arktype/schema";
import { RawScope, scope } from "./scope.js";
export const tsGenerics = {};
export const ambient = scope(keywordNodes);
RawScope.ambient = ambient.raw;
export const ark = ambient.export();
export const type = ambient.type;
export const match = ambient.match;
export const define = ambient.define;
export const declare = ambient.declare;
